module.exports = __webpack_public_path__ + "img/bad-skill-star.e82c5dc0.svg";